import { ReactNode, createContext, useState, useContext } from 'react'
import { BondRating } from '@prisma/client'
import { Discount } from 'containers/calculator/entities/discounts'

export type Values = {
    amount: number
    term: number
    rating: Extract<BondRating, 'CCC_PLUS' | 'BBB_PLUS' | 'AA'>
    discounts: Discount[]
}

export type CalculatorInputContextValue = {
    values: Values
    setValues: (values: Values) => any
}

const CalculatorInputContext = createContext<CalculatorInputContextValue | null>(null)

export const WithCalculatorInput = ({
    children,
    defaultInputValues,
}: {
    children: ReactNode
    defaultInputValues?: Values
}) => {
    const [values, setValues] = useState<Values>(
        defaultInputValues ?? {
            amount: 50000,
            term: 4,
            rating: BondRating.AA,
            discounts: [],
        },
    )
    return (
        <CalculatorInputContext.Provider
            value={{
                values,
                setValues,
            }}
        >
            {children}
        </CalculatorInputContext.Provider>
    )
}

export const useCalculatorInput = () => {
    const context = useContext(CalculatorInputContext)
    if (context === null) {
        throw new Error('useCalculatorInput must be used within a CalculatorInputContext')
    }
    return context
}
